var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "TcHeader" }, [
    _c("nav", { staticClass: "flex justify-center" }, [
      _c(
        "div",
        { staticClass: "logo cursor-pointer", on: { click: _vm.reloadPage } },
        [
          _c("img", {
            attrs: { src: "/assets/img/coiico-logo.svg", alt: "coiico logo" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.$root.page == "welcome"
        ? _c("div", { staticClass: "flex items-center" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.page != "welcome"
        ? _c(
            "div",
            {
              staticClass: "flex-grow text-center w-full",
              attrs: { id: "headerUser" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "px-2 flex justify-center items-center overflow-hidden"
                },
                [
                  _vm.$root.access_token && _vm.$root.user
                    ? [
                        _c("img", {
                          staticClass: "h-12 w-12 rounded-full",
                          attrs: { src: _vm.$root.user.avatar }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-xl ml-3" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$root.user.name) +
                              ", Nº Colegiado " +
                              _vm._s(_vm.$root.user.number) +
                              "\n          "
                          )
                        ])
                      ]
                    : _vm.$root.external_user
                    ? [
                        _c("span", { staticClass: "h-12 w-12" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-xl ml-3 text-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$root.external_user.name) +
                              "\n            " +
                              _vm._s(_vm.$root.external_user.surname1) +
                              "\n            " +
                              _vm._s(_vm.$root.external_user.surname2) +
                              ", DNI " +
                              _vm._s(_vm.$root.external_user.dni) +
                              "\n          "
                          )
                        ])
                      ]
                    : [_c("span", { staticClass: "w-full" })]
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.access_token && _vm.$root.user
        ? _c(
            "div",
            {
              staticClass: "header-nav-item mr-10 whitespace-nowrap",
              attrs: { id: "headerLogout" },
              on: {
                click: function($event) {
                  return _vm.$root.logOut()
                }
              }
            },
            [
              _c("span", { staticClass: "mr-3 whitespace-nowrap" }, [
                _vm._v("Cerrar sesión")
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10 text-gray-400",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d:
                        "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.page == "login-public"
        ? _c(
            "div",
            {
              staticClass: "header-nav-item ml-auto mr-10 whitespace-nowrap",
              on: {
                click: function($event) {
                  return _vm.$root.logOut()
                }
              }
            },
            [
              _c("span", { staticClass: "mr-3 whitespace-nowrap" }, [
                _vm._v("Terminar sesión pública")
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10 text-gray-400",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d:
                        "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.access_token && _vm.$root.user
        ? _c(
            "div",
            {
              staticClass: "header-nav-item",
              attrs: { id: "headerHome" },
              on: {
                click: function($event) {
                  return _vm.$root.setPage("home")
                }
              }
            },
            [
              _c("span", { staticClass: "mr-3" }, [_vm._v("Inicio")]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10 text-gray-400",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d:
                        "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$root.access_token && _vm.$root.page != "welcome"
        ? _c(
            "div",
            {
              staticClass: "header-nav-item flex-grow text-right",
              on: {
                click: function($event) {
                  return _vm.$root.setPage("welcome")
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-10 w-10 text-gray-400 ml-auto",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d:
                        "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto text-left px-2" }, [
      _c("img", {
        staticStyle: {
          "margin-left": "auto",
          "margin-right": "auto",
          height: "70px"
        },
        attrs: { src: "/assets/img/gobierno canarias.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto text-center px-2" }, [
      _c("img", {
        staticStyle: { height: "70px" },
        attrs: { src: "/assets/img/unioneuropea.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto text-right px-2" }, [
      _c("img", {
        staticStyle: {
          "margin-left": "auto",
          "margin-right": "auto",
          height: "70px"
        },
        attrs: { src: "/assets/img/canariasavanza.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto text-center px-2" }, [
      _vm._v("\n        FONDO EUROPEO DE "),
      _c("br"),
      _vm._v("DESARROLLO REGIONAL\n      ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }